import { FC, useEffect, useState } from "react";
import styles from "./FooterPage.module.scss";
import { getServices } from "../../api/services";
import { IService } from "../../types/service";
import heart from "../../images/footer/heart.svg";

export const Abbreviation: FC = () => {
  const [dataServices, setDataServices] = useState<Array<IService>>([]);
  const fetchData = async () => {
    const data: IService[] = await getServices();
    setDataServices(data.filter((item) => item.isDeleted === false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={styles.servicePage}>
      <div className={styles.infomation_conteiner}>
        <h2 className={styles.infomation__subtitle}>Liste</h2>
        <h1 className={styles.infomation__title}>Abkürzungen</h1>
      </div>
      <div className={styles.service_list}>
        {dataServices.map((item) => (
          <div className={styles.service_list_item} key={item.id}>
            <div className={styles.service}>
              <img src={heart} alt="Icon not" />
              <p className={styles.service_text}>{item.serviceName}</p>
            </div>
            <p className={styles.service_description}>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
